import React from 'react';
import PropTypes from 'prop-types';
import {
  Menu,
  MenuItem,
  withStyles,
} from '@material-ui/core';

import MoreVertIcon from '@material-ui/icons/MoreVert';

const styles = (theme) => ({
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexFlow: 'row',
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: 0,
    padding: '10px 8px',
    margin: '6px 0 6px 0',
    textTransform: 'none',
    width: '100%',
    transition: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f4f6f8',
    }
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: '1.5rem',
    margin: '0 0 0 18px'
  },
  iconOptions: {
    margin: '0 0 0 -10px'
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
    color: '#000',
    backgroundColor: 'transparent',
    fontSize: '1rem',
    padding: '1px 0 0 7px',
    border: 0,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  active: {
    color: theme.palette.primary.main,
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium
    },
    '& $icon': {
      color: theme.palette.primary.main
    }
  },
  iconAddFolder: {
    position: 'relative',
    margin: '-1px 0 0 0',
    padding: 0,
    fontSize: 20
  }
});

class MenuItemCustom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      classes,
    } = this.props;
    const open = Boolean(this.state.anchorEl);

    return (
      <span>
        <MoreVertIcon
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={this.handleClick}
          className={classes.iconAddGroup}
          style={this.props.style}
        />
        <Menu
          id="long-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          open={open}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: 210,
              width: '20ch',
            },
          }}
        >
          {this.props.items.map((item) => {
            return (
              <MenuItem key={`${this.props.id}${item.title}`} onClick={(event) => {
                event.stopPropagation();
                this.handleClose();
                return item.onCustomClick(this.props.id);
              }}>
                {item.title}
              </MenuItem>
            );
          })}
        </Menu>
      </span>
    );
  }
}

MenuItemCustom.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  items: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
};

export default (withStyles(styles)(MenuItemCustom));
